import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon19: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 14.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 14 20" width={width} height={height} {...props}>
      <Path
        d="M8.47601 3.36511e-06C8.60901 3.36511e-06 8.73599 0.0529995 8.82999 0.145999L13.846 5.16201C13.939 5.25601 13.992 5.38301 13.992 5.51601L14 19.5C14 19.776 13.776 20 13.5 20H0.5C0.224 20 0 19.776 0 19.5V0.500003C0 0.224003 0.224 3.36511e-06 0.5 3.36511e-06H8.47601ZM8.26901 1H1V19H13L12.992 5.72301L8.26901 1ZM6.5 6.763C6.776 6.763 7 6.987 7 7.263V8.082C7.352 8.139 7.70199 8.241 8.04599 8.375C8.37699 8.504 8.632 8.63499 8.785 8.72699C9.021 8.86999 9.09701 9.177 8.95401 9.413C8.81101 9.65 8.50401 9.72601 8.26801 9.58301C8.16101 9.51801 7.95501 9.41301 7.68301 9.30701C7.23301 9.13101 6.77699 9.02701 6.34799 9.02701C5.45999 9.02701 4.841 9.45201 4.841 10.001C4.841 10.61 5.319 10.96 6.771 11.536L6.91299 11.592C8.67799 12.29 9.33301 12.754 9.33301 13.851C9.33301 15.056 8.42101 15.775 7.00101 15.913L7 16.715C7 16.991 6.776 17.215 6.5 17.215C6.224 17.215 6 16.991 6 16.715L5.99899 15.917C5.43999 15.868 4.95499 15.733 4.54199 15.534C4.20999 15.375 3.98499 15.206 3.86099 15.077C3.66899 14.879 3.67399 14.562 3.87299 14.37C4.07099 14.178 4.38799 14.184 4.57999 14.382C4.62599 14.43 4.75601 14.528 4.97601 14.633C5.36801 14.822 5.86401 14.938 6.47501 14.938C7.70801 14.938 8.33301 14.533 8.33301 13.851C8.33301 13.363 7.90301 13.059 6.54501 12.521L6.40302 12.465C4.56102 11.736 3.841 11.209 3.841 10.001C3.841 8.90501 4.78499 8.16301 5.99899 8.04401L6 7.263C6 6.987 6.224 6.763 6.5 6.763ZM8.49799 3.36511e-06C8.77399 -0.000996635 8.999 0.221004 9 0.498004L9.022 5.002L13.502 5.01601C13.778 5.01701 14.001 5.24101 14 5.51801C13.999 5.79401 13.774 6.01701 13.498 6.01601L8.522 6C8.248 5.999 8.02499 5.777 8.02399 5.502L8 0.502002C7.999 0.226002 8.22099 0.00100337 8.49799 3.36511e-06Z"
        fill="#73C177"
      />
    </Icon>
  )
}
